import { GroupCompanyEntity } from "../../entity/GroupCompanyEntity";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { getFullYear } from "../../utils/date/date";

const GroupsCollection = new Mongo.Collection("Groups", {
    connection: null
});

export class GroupOfCompaniesGateway extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlGroupCompanies = `${publicSettings.aws.baseUrls.groupCompanies}/group-companies`;
    constructor({ Company } = {}) {
        super(GroupsCollection);
        this.Company = Company;
    }

    async populate({ accountingId, user }) {
        try {
            console.time("POPULANDO GROUPOS");
            const groups = await this.find({
                accountingId,
                user
            });

            this.createMany(groups);
            console.timeEnd("POPULANDO GROUPOS");
            return groups;
        } catch (err) {
            console.error("err", err);
        }
    }

    createMany(data = []) {
        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];

            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();

            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();

            if (document.dateFrom)
                document.dateFrom = new Date(document.dateFrom).getTime();

            if (document.companyIds) {
                const companies = this.Company.findCollection(
                    {
                        _id: { $in: document.companyIds }
                    },
                    {
                        fields: {
                            name: 1,
                            lastFee: 1
                        }
                    },
                    "array"
                );

                document.companyNames = companies.map((c) => c.name);
                document.fees = companies.reduce(
                    (prev, acc) => Number(prev) + Number(acc.lastFee || 0),
                    0
                );
            }

            this.create(document);
        }

        return true;
    }

    /**
     * @public
     * Método para criar um grupo
     * @param {Object} group { companyIds: Array of String, name: "String", "dateFrom": new Date(), user: { _id: "", roles: "String" }, accountingId: "String", picture: "String" }
     * @return {String} id do grupos
     */
    async insertOne(group = {}) {
        try {
            let response = await this.HttpAdapter.call(
                `${this.baseUrlGroupCompanies}/create-one`,
                { ...group }
            );

            return response._id;
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @public
     * Método para criar um grupo
     * @param {Object} group { companyIds: Array of String, name: "String", "dateFrom": new Date(), user: { _id: "", roles: "String" }, accountingId: "String", picture: "String" }
     * @return {String} id do grupos
     */
    async updateOne({ group }) {
        try {
            let response = await this.HttpAdapter.call(
                `${this.baseUrlGroupCompanies}/update-by-id`,
                {
                    id: group._id,
                    name: group.name,
                    dateFrom: group.dateFrom,
                    companyIds: group.companyIds,
                    picture: group.picture,
                    accountingId: group.accountingId,
                    accountingName: group.accountingName,
                    // Identidade informada no cadastro. Este payload e montado campo a campo,
                    // entao um campo novo que nao entre aqui e descartado em silencio no editar.
                    document: group.document,
                    taxation: group.taxation,
                    segmentGroup: group.segmentGroup
                }
            );

            return response;
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @public
     * Método para buscar os grupos
     * @param {Object} group { companyIds: Array of String, name: "String", "dateFrom": new Date(), user: { _id: "", roles: "String" } }
     * @return {Array} lista dos grupos
     */
    async find({ accountingId, user }) {
        try {
            let response = await this.HttpAdapter.call(
                `${this.baseUrlGroupCompanies}/get-segment-info`,
                {
                    accountingId,
                    user
                }
            );

            const groups = response.list || [];

            return groups.map((props) => {
                const groupEntity = GroupCompanyEntity.restore(props);
                return groupEntity;
            });
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    async findById(id) {
        try {
            let response = await this.HttpAdapter.call(
                `${this.baseUrlGroupCompanies}/get-by-id`,
                {
                    id
                }
            );

            return response.result;
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @public
     * Método para buscar os grupos
     * @async
     * @param {Object} group { companyIds: Array of String, name: "String", "dateFrom": new Date(), user: { _id: "", roles: "String" } }
     * @return {Promise<Array>} lista dos grupos
     */
    async remove(_id) {
        try {
            let response = await this.HttpAdapter.call(
                `${this.baseUrlGroupCompanies}/remove-by-id`,
                {
                    id: _id
                }
            );

            return response;
        } catch (error) {
            console.error(error);
        }
    }

    sliceYearsByDateFrom({ years, dateFrom }) {
        if (!years || !dateFrom) return [];

        const sortedYears = years.sort();

        const groupStartYear = getFullYear(dateFrom);

        const yearIndex = sortedYears.indexOf(groupStartYear);

        return sortedYears.slice(yearIndex);
    }
}
